var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"botonCircularMediano",attrs:{"ripple":false,"disabled":true}},[_c('Icono',{attrs:{"value":_vm.iconoMicrofono}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22dfb288","hasScoped":false,"buble":{"transforms":{}}}!./src/components/Microfono/Microfono.html
// module id = 941
// module chunks = 0